var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosedGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66675 9.16667V5.83333C6.66675 4.94928 7.01794 4.10143 7.64306 3.47631C8.26818 2.85119 9.11603 2.5 10.0001 2.5C10.8841 2.5 11.732 2.85119 12.3571 3.47631C12.9822 4.10143 13.3334 4.94928 13.3334 5.83333V9.16667M5.83341 9.16667H14.1667C15.0872 9.16667 15.8334 9.91286 15.8334 10.8333V15.8333C15.8334 16.7538 15.0872 17.5 14.1667 17.5H5.83341C4.91294 17.5 4.16675 16.7538 4.16675 15.8333V10.8333C4.16675 9.91286 4.91294 9.16667 5.83341 9.16667ZM10.8334 13.3333C10.8334 13.7936 10.4603 14.1667 10.0001 14.1667C9.53984 14.1667 9.16675 13.7936 9.16675 13.3333C9.16675 12.8731 9.53984 12.5 10.0001 12.5C10.4603 12.5 10.8334 12.8731 10.8334 13.3333Z",
    stroke: "#4D5A81",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedGroup);
export default __webpack_public_path__ + "static/media/closed-group.2647c6e2aa46b04cce51cb58b4d905e7.svg";
export { ForwardRef as ReactComponent };